<template>
    <div class="newsletter py-4 py-lg-5 pt-5 mt-xl-0 pt-xl-0 background-image">
        <div class="container py-0 py-lg-5">
            <div class="row justify-content-center text-lg-left">
                <div class="col-xl-12 col-10 mt-3">
                    <h2 class="font-glacial-bold text-center text-white font-42">
                        {{data.titulo}}
                    </h2>
                </div>

                <div class="col-12 mb-4 mb-sm-0">
                    <form @submit.prevent="submit">
                        <div class="row d-box align-items-center text-center mx-xl-1 mx-4">

                            <div class="input-group">
                                <b-form-input v-model="form.email" type="email" placeholder="E-mail" class="input-newsletter form-control mt-4"></b-form-input>
                                <b-form-invalid-feedback class="text-white">
                                    {{showError('email')}}
                                </b-form-invalid-feedback>
                                <span class="input-group-addon input-group-addon-btn bg-white">
                                    <b-btn :state="checkError('email')" class="submit-newsletter font-glacial-bold btn-opacidade" @click="submit" :disabled="loading || success">ENVIAR</b-btn>
                                </span>
                            </div>
                            <div class="col-12" v-if="errors && errors.message">
                                <b-alert show variant="warning">
                                    {{errors.message}}
                                </b-alert>
                            </div>

                            <div class="col-12" v-if="success && success.message">
                                <b-alert show variant="success">
                                    {{success.message}}
                                </b-alert>
                            </div>

                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        data: null
    },

    data(){
        return {
            errors: null,
            success: null,
            loading: false,

            form: {
                email: ''
            }
        }
    },

    methods:{
        submit(){
           this.$router.push({
                name: 'page', 
                
                params:{
                    "page":"fale-conosco"
                }, 

                query: {
                    email: this.form.email
                }
            })

            // this.$router.push('/fale-conosco?email='+this.form.email)

        },
        
        checkError(field){
            if(this.errors && this.errors.invalidFields){
                for (let index = 0; index < this.errors.invalidFields.length; index++) {
                    const e = this.errors.invalidFields[index];

                    if (e.into.includes(field)){
                        return false
                    }
                    
                }
            }

            return null;
        },
        
        showError(field){
            if(this.errors && this.errors.invalidFields){
                for (let index = 0; index < this.errors.invalidFields.length; index++) {
                    const e = this.errors.invalidFields[index];

                    if (e.into.includes(field)){
                        return e.message
                    }
                    
                }
            }

            return null;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/newsletter.vue